/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import ControlButton from '../core/control/control-button';
import SetupRoot from '../core/setup/setup-root';
import ViewerRoot from '../core/viewer/root/viewer-root';
import template from './player-root.html';

export default {
  name: 'PlayerRoot',
  template,
  components: { SetupRoot, ViewerRoot },
  created() {
    // Příznak, že se má po dokončení zobrazení dalšího slajdu odeslat report.
    this.reportEnabled = true;
    // Zpoždění, kvůli pomalému vykreslování. Hodnota určena experimentálně na emulátoru.
    // TODO #84 Přidat do konfigurace, nebo lépe ošetřit.
    this.reportDelay = 250;
    // Časovač zpoždění. Zároveň slouží k zablokování paralelního odeslání reportů.
    this.reportTimeout = null;
    // Naslouchání událostem.
    const { controlManager, device } = this.$root;
    controlManager.on('buttonDown', this.onButtonDown);
    device.on('content', this.onContent);
    // Aktualizace, jaký modul zobrazovat.
    this.refresh();
  },
  data() {
    return {
      setupVisible: false,
      viewerVisible: false
    };
  },
  destroyed() {
    // Zrušení naslouchání událostem.
    const { controlManager, device } = this.$root;
    controlManager.off('buttonDown', this.onButtonDown);
    device.off('content', this.onContent);
    // Zrušení časovačů.
    clearTimeout(this.reportTimeout);
  },
  methods: {
    back() {
      if (this.setupVisible) {
        // Setup spravuje tlačítko zpět samostatně.
        return;
      }
      this.$root.appManager.exit();
    },
    handleError(error) {
      this.$root.logger.error(error);
    },
    onButtonDown(controlButton) {
      if (controlButton === ControlButton.Back) {
        this.back();
      }
    },
    onContent() {
      // Nový obsah, odblokování odesílání obsahu na prvním slajdu.
      this.reportEnabled = true;
    },
    onError(error) {
      this.handleError(error);
    },
    onSetupFinish() {
      this.refresh();
    },
    onViewerEntered() {
      this.report();
    },
    refresh() {
      const installed = this.$root.session.isInstalled();
      this.setupVisible = !installed;
      this.viewerVisible = installed;
    },
    report() {
      // Report informací o zařízení se odesílá pouze u prvního slajdu a neduplikuje se.
      if (this.reportEnabled && !this.reportTimeout) {
        // Počká se na vykreslení DOM.
        this.$nextTick()
          .then(() => {
            // Kvůli pomalému vykreslování se přidá krátké zpoždění.
            // TODO #84 Hotfix zpoždění při HW reportu.
            this.reportTimeout = setTimeout(() => {
              // Odblokování spuštění se zpožděním.
              this.reportTimeout = null;
              // Odeslání reportu.
              this.$root.device
                .report()
                .catch((error) => this.handleError(error));
            }, this.reportDelay);
          })
          .catch((error) => this.handleError(error));
      }
      // Zablokování odesílání obsahu na jiném než prvním slajdu.
      this.reportEnabled = false;
    }
  }
};
